import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useIsTradeInApplied } from '~/context/common/TradeContext';
import sendMessageToNative from './sendMessageToNative';

export default function useTradeInAppliedDispatcher(): void {
  const isTradeInApplied = useIsTradeInApplied();

  useSubsequentEffect(() => {
    sendMessageToNative(DispatcherEvent.ToggleTradeIn, { isTradeInApplied });
  }, [isTradeInApplied]);
}
